import { StyleSheet } from 'react-native';

export const friendCardSkeletonStyles = StyleSheet.create({
  cardContent: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: 24,
    paddingBottom: 18,
    paddingHorizontal: 12,
    position: 'relative',
    width: '100%',
  },
  avatarContainer: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusDotContainer: {
    position: 'absolute',
    bottom: 4,
    right: 4,
    borderColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white', // Background for the border effect
  },
});

export interface FriendCardSkeletonDimensions {
  avatarMarginBottom: number;
  statusDotSize: number;
  statusDotBorder: number;
  fontSizeName: number;
  fontSizeStat: number;
  nameMarginBottom: number;
}

/** Wrapper style for name skeleton (marginBottom from dimensions) */
export const getSkeletonNameWrapperStyle = (marginBottom: number) =>
  StyleSheet.create({ wrapper: { marginBottom } }).wrapper;

export const getFriendCardSkeletonDynamicStyles = (dimensions: FriendCardSkeletonDimensions) =>
  StyleSheet.create({
    avatarContainer: {
      ...friendCardSkeletonStyles.avatarContainer,
      marginBottom: dimensions.avatarMarginBottom,
    },
    statusDot: {
      width: dimensions.statusDotSize,
      height: dimensions.statusDotSize,
      borderRadius: dimensions.statusDotSize / 2,
      borderWidth: dimensions.statusDotBorder,
    },
    name: {
      marginBottom: dimensions.nameMarginBottom,
      height: dimensions.fontSizeName + 4,
    },
    stat: {
      height: dimensions.fontSizeStat + 4,
    },
  });

